import { call, takeLatest, put } from 'redux-saga/effects';
import { post, get } from '../../helpers/server';

function* getBacktestStrategy(action) {
    try {
        const resp = yield call(get, "/backtest/strategy?u=" + action.payload.u);
        if (resp.status === 1) {
            yield put({ type: "get_backtest_strategy_success", strategyItems: resp.si, permission: resp.p });
        } else {
            if (resp.status === 4) {
                yield put({ type: "non_user" });
            }
            yield put({ type: "get_backtest_strategy_fail", status: resp.status });
        }
    } catch (e) {
        yield put({ type: "get_backtest_strategy_fail", status: 0 });
    }
}

function* getSingleStockItems(action) {
    try {
        const resp = yield call(post, "/backtest/items", action.payload);
        if (resp.status === 1) {
            yield put({ type: "get_single_stock_success", backtestResult: resp.bs, symbols: resp.sl });
        } else {
            if (resp.status === 2) {
                yield put({ type: "non_user" });
            }
            yield put({ type: "get_single_stock_fail", status: resp.status });
        }
    } catch (e) {
        yield put({ type: "get_single_stock_fail", status: 0 });
    }
}

function* getSingleSymbolItems(action) {
    try {
        const resp = yield call(post, "/backtest/symbolToBacktestResult", action.payload);
        if (resp.status === 1) {
            yield put({ type: "get_single_symbol_success", backtestResult: resp.bs });
        } else {
            if (resp.status === 2) {
                yield put({ type: "non_user" });
            }
            yield put({ type: "get_single_symbol_fail", status: resp.status });
        }
    } catch (e) {
        yield put({ type: "get_single_symbol_fail", status: 0 });
    }
}

function* removeBacktest(action) {
    try {
        const resp = yield call(post, "/backtest/remove", action.payload);
        if (resp.status === 1) {
            yield put({ type: "get_remove_backtest_success", backtestResult: resp.bs, symbols: resp.sl });
        } else {
            if (resp.status === 2) {
                yield put({ type: "non_user" });
            }
            yield put({ type: "get_remove_backtest_fail", status: resp.status });
        }
    } catch (e) {
        yield put({ type: "get_remove_backtest_fail", status: 0 });
    }
}

function* getBacktestGrid(action) {
    try {
        const resp = yield call(get, "/backtest/grid?u=" + action.payload.u);
        if (resp.status === 1) {
            yield put({ type: "get_backtest_grid_success", permission: resp.p });
        } else {
            if (resp.status === 2) {
                yield put({ type: "non_user" });
            }
            yield put({ type: "get_backtest_grid_fail", status: resp.status });
        }
    } catch (e) {
        yield put({ type: "get_backtest_grid_fail", status: 0 });
    }
}

function* getAIGrid(action) {
    try {
        const resp = yield call(get, "/backtest/ai?u=" + action.payload.u);
        if (resp.status === 1) {
            yield put({ type: "get_ai_grid_success", permission: resp.p });
        } else {
            if (resp.status === 2) {
                yield put({ type: "non_user" });
            }
            yield put({ type: "get_ai_grid_fail", status: resp.status });
        }
    } catch (e) {
        yield put({ type: "get_ai_grid_fail", status: 0 });
    }
}

function* getExploreBacktest(action) {
    try {
        const resp = yield call(get, "/backtest/explore?u=" + action.payload.u);
        if (resp.status === 1) {
            yield put({ type: "get_explore_grid_success", permission: resp.p });
        } else {
            if (resp.status === 2) {
                yield put({ type: "non_user" });
            }
            yield put({ type: "get_explore_grid_fail", status: resp.status });
        }
    } catch (e) {
        yield put({ type: "get_explore_grid_fail", status: 0 });
    }
}

function* getBatchInfo(action) {
    try {
        const resp = yield call(get, "/batchBacktest/info?u=" + action.payload.u + "&b=" + action.payload.b);
        if (resp.status === 1) {
            yield put({ type: "get_batch_info_success", batchInfo: resp.bi, permission: resp.p });
        } else {
            if (resp.status === 2) {
                yield put({ type: "non_user" });
            }
            yield put({ type: "get_batch_info_fail", status: resp.status });
        }
    } catch (e) {
        yield put({ type: "get_batch_info_fail", status: 0 });
    }
}

function* getOptInfo(action) {
    try {
        const resp = yield call(get, "/optBacktest/info?u=" + action.payload.u + "&b=" + action.payload.b);
        if (resp.status === 1) {
            yield put({ type: "get_opt_info_success", optInfo: resp.bi, permission: resp.p });
        } else {
            if (resp.status === 2) {
                yield put({ type: "non_user" });
            }
            yield put({ type: "get_opt_info_fail", status: resp.status });
        }
    } catch (e) {
        yield put({ type: "get_opt_info_fail", status: 0 });
    }
}

function* getOptimizeItems(action) {
    try {
        const resp = yield call(post, "/batchBacktest/items", action.payload);
        if (resp.status === 1) {
            yield put({ type: "get_optimize_success", backtestResult: resp.bs, symbols: resp.sl });
        } else {
            if (resp.status === 2) {
                yield put({ type: "non_user" });
            }
            yield put({ type: "get_optimize_fail", status: resp.status });
        }
    } catch (e) {
        yield put({ type: "get_optimize_fail", status: 0 });
    }
}

function* getOptimizeSymbol(action) {
    try {
        const resp = yield call(post, "/batchBacktest/optimizeSymbol", action.payload);
        if (resp.status === 1) {
            yield put({ type: "get_optimize_symbol_success", backtestResult: resp.bs });
        } else {
            if (resp.status === 2) {
                yield put({ type: "non_user" });
            }
            yield put({ type: "get_optimize_symbol_fail", status: resp.status });
        }
    } catch (e) {
        yield put({ type: "get_optimize_symbol_fail", status: 0 });
    }
}

function* removeOptimizeBacktest(action) {
    try {
        const resp = yield call(post, "/batchBacktest/remove", action.payload);
        if (resp.status === 1) {
            yield put({ type: "get_remove_optimize_success", backtestResult: resp.bs, symbols: resp.sl });
        } else {
            if (resp.status === 2) {
                yield put({ type: "non_user" });
            }
            yield put({ type: "get_remove_optimize_fail", status: resp.status });
        }
    } catch (e) {
        yield put({ type: "get_remove_optimize_fail", status: 0 });
    }
}

function* getOptItems(action) {
    try {
        const resp = yield call(post, "/optBacktest/items", action.payload);
        if (resp.status === 1) {
            yield put({ type: "get_opt_success", backtestResult: resp.bs, symbols: resp.sl });
        } else {
            if (resp.status === 2) {
                yield put({ type: "non_user" });
            }
            yield put({ type: "get_opt_fail", status: resp.status });
        }
    } catch (e) {
        yield put({ type: "get_opt_fail", status: 0 });
    }
}

function* getOptSymbol(action) {
    try {
        const resp = yield call(post, "/optBacktest/optimizeSymbol", action.payload);
        if (resp.status === 1) {
            yield put({ type: "get_opt_symbol_success", backtestResult: resp.bs });
        } else {
            if (resp.status === 2) {
                yield put({ type: "non_user" });
            }
            yield put({ type: "get_opt_symbol_fail", status: resp.status });
        }
    } catch (e) {
        yield put({ type: "get_opt_symbol_fail", status: 0 });
    }
}

function* removeOptBacktest(action) {
    try {
        const resp = yield call(post, "/optBacktest/remove", action.payload);
        if (resp.status === 1) {
            yield put({ type: "get_remove_opt_success", backtestResult: resp.bs, symbols: resp.sl });
        } else {
            if (resp.status === 2) {
                yield put({ type: "non_user" });
            }
            yield put({ type: "get_remove_opt_fail", status: resp.status });
        }
    } catch (e) {
        yield put({ type: "get_remove_opt_fail", status: 0 });
    }
}

function* getRollingGrid(action) {
    try {
        const resp = yield call(get, "/rollingBacktest/getRollingSymbols?u=" + action.payload.u);
        if (resp.status === 1) {
            yield put({ type: "get_rolling_grid_success", permission: resp.p, symbolItems: resp.st });
        } else {
            yield put({ type: "get_rolling_grid_fail", status: resp.status });
        }
    } catch (e) {
        yield put({ type: "get_rolling_grid_fail", status: 0 });
    }
}

function* GetRollingItems(action) {
    try {
        const resp = yield call(post, "/rollingBacktest/items", action.payload);
        if (resp.status === 1) {
            yield put({ type: "get_rolling_items_success", rollingResult: resp.rs, symbols: resp.sl });
        } else {
            if (resp.status === 2) {
                yield put({ type: "non_user" });
            }
            yield put({ type: "get_rolling_items_fail", status: resp.status });
        }
    } catch (e) {
        yield put({ type: "get_rolling_items_fail", status: 0 });
    }
}

function* GetRollingSymbol(action) {
    try {
        const resp = yield call(post, "/rollingBacktest/rollingSymbol", action.payload);
        if (resp.status === 1) {
            yield put({ type: "get_rolling_symbol_success", rollingResult: resp.rs });
        } else {
            if (resp.status === 2) {
                yield put({ type: "non_user" });
            }
            yield put({ type: "get_rolling_symbol_fail", status: resp.status });
        }
    } catch (e) {
        yield put({ type: "get_rolling_symbol_fail", status: 0 });
    }
}

function* removeRollingBacktest(action) {
    try {
        const resp = yield call(post, "/rollingBacktest/remove", action.payload);
        if (resp.status === 1) {
            yield put({ type: "get_remove_rolling_success", rollingResult: resp.rs, symbols: resp.sl });
        } else {
            if (resp.status === 2) {
                yield put({ type: "non_user" });
            }
            yield put({ type: "get_remove_rolling_fail", status: resp.status });
        }
    } catch (e) {
        yield put({ type: "get_remove_rolling_fail", status: 0 });
    }
}

function* getRollingSymbols(action) {
    try {
        const resp = yield call(get, "/rollingBacktest/getRollingSymbols?u=" + action.payload.UserId + "&kw=" + action.payload.keywords);
        if (resp && resp.status === 1) {
            yield put({ type: 'get_rolling_symbols_success', symbolItems: resp.st });
        } else {
            if (resp.status === 2) {
                yield put({ type: "non_user" });
            }
            yield put({ type: 'get_rolling_symbols_fail', status: resp.status });
        }
    } catch (e) {
        yield put({ type: "get_rolling_symbols_fail", status: 0 });
    }
}

function* Effect() {
    yield takeLatest('action_get_backtest_strategy', getBacktestStrategy);

    yield takeLatest('action_get_single_stock_items', getSingleStockItems);
    yield takeLatest('action_get_single_symbol_items', getSingleSymbolItems);

    yield takeLatest('action_remove_backtest', removeBacktest);

    yield takeLatest('action_get_backtest_grid', getBacktestGrid);
    yield takeLatest('action_get_ai_grid', getAIGrid);

    yield takeLatest('action_get_explore_grid', getExploreBacktest);

    yield takeLatest('action_get_batch_info', getBatchInfo);

    yield takeLatest('action_get_opt_info', getOptInfo);

    yield takeLatest('action_get_optimize_items', getOptimizeItems);
    yield takeLatest('action_get_optimize_symbol', getOptimizeSymbol);

    yield takeLatest('action_remove_optimize', removeOptimizeBacktest);

    yield takeLatest('action_get_opt_items', getOptItems);
    yield takeLatest('action_get_opt_symbol', getOptSymbol);

    yield takeLatest('action_remove_opt', removeOptBacktest);

    yield takeLatest('action_get_rolling_grid', getRollingGrid);

    yield takeLatest('action_get_rolling_items', GetRollingItems);
    yield takeLatest('action_get_rolling_symbol', GetRollingSymbol);
    yield takeLatest('action_remove_rolling', removeRollingBacktest);

    yield takeLatest('action_get_rolling_symbols', getRollingSymbols);
}

export default Effect;